import { render } from "./Block.vue?vue&type=template&id=c9af1bc6&scoped=true"
import script from "./Block.vue?vue&type=script&lang=ts"
export * from "./Block.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-c9af1bc6"

export default script